import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { blogData } from "../data";
import "./blog.scss";
const Blog = () => {
  return (
    <div className="home-blog">
      <div className="left-side">
        <h1 className="big-title">
          <FormattedMessage
            id="Read"
            defaultMessage="Read Our Blog"
          />
        </h1>

        <div className="img"></div>
      </div>

      <div className="right-side">
        {blogData.map((props, i) => {
          return (
            <div className="blogCard" key={i}>
              <div className="icon">
                <BsArrowRight />
                <div className="circle"></div>
              </div>
              <div className="content">
                <span>
                  {props.position} - {props.date}
                </span>
                <h1 className="small-title">{props.title}</h1>
                <p className="def-text">{props.text}</p>
                <Link to={props.to}>
                  <FormattedMessage
                    id="ReadMore"
                    defaultMessage="Read more"
                  />
                </Link>
              </div>
            </div>
          );
        })}

        <Link className="lastlink" to="/Blog">
          <FormattedMessage
            id="ViewAllBlog"
            defaultMessage="View All In Blog"
          />
        </Link>
      </div>
    </div>
  );
};

export default Blog;
